<template>
  <div class="bg-cream">
    <Nav color="blue" :init-banner-state="true"></Nav>
    <section id="events" class="padding-main">
      <div class="container-large">
        <h1 class="blue bottom-line">Upcoming Events</h1>
        <div id="sorted-events" class="container-mid">
          <div v-for="monthEvent in allEvents" class="mb-2">
            <h2 class="blue">{{monthEvent.month}}</h2>
            <div class="col gap-1">
              <EventThumbnail v-for="(eventInfo, index) in monthEvent.events" :eventInfo="eventInfo" :index="index"/>
            </div>
          </div>
        </div>
      </div>
    </section>
    <SmallPreFooter></SmallPreFooter>
    <Footer :borderTop=false></Footer>
  </div>
</template>

<script>
import Nav from "@/components/Nav.vue";
import EventThumbnail from "@/components/EventThumbnail.vue";
import Footer from "@/components/Footer.vue";
import SmallPreFooter from "@/components/SmallPreFooter.vue";

export default {
  name: "Events",
  components: {SmallPreFooter, Footer, EventThumbnail, Nav},
  computed: {
    allEvents() {
      return this.$store.getters.getAllUpcomingEvents;
    }
  }
}
</script>

<style scoped lang="scss">
#events {
  h2 {
    font-size: 1.6em;
  }
}

#sorted-events {
  margin: 4em auto 6em auto;
}
</style>